const phoneNumberRegex = /^\+?[-\s0-9]*(\([-\s0-9]+\)[\d\s])?[-\s0-9]*([0-9 ]{1,})$/;

const isPhoneNumber = (value) => phoneNumberRegex.test(value);

export default isPhoneNumber;
